/** Collaborator management API functions. */

import { apiGet, apiPost, apiPatch, apiDelete } from '@/api/client';

export interface Collaborator {
  userId: string;
  email: string;
  role: 'editor' | 'viewer';
  grantedAt: string;
}

export async function listCollaborators(
  mapId: string,
): Promise<Collaborator[]> {
  const response = await apiGet<{ collaborators: Collaborator[] }>(
    `/maps/${mapId}/collaborators`,
  );
  return response.collaborators;
}

export function inviteCollaborator(
  mapId: string,
  email: string,
  role: 'editor' | 'viewer',
): Promise<Collaborator> {
  return apiPost<Collaborator>(`/maps/${mapId}/collaborators`, { email, role });
}

export function removeCollaborator(
  mapId: string,
  userId: string,
): Promise<void> {
  return apiDelete(`/maps/${mapId}/collaborators/${userId}`);
}

export function updateCollaboratorRole(
  mapId: string,
  userId: string,
  role: 'editor' | 'viewer',
): Promise<void> {
  return apiPatch(`/maps/${mapId}/collaborators/${userId}`, { role });
}
